<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Edit Student Registration</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" align="center">
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete rounded :items="ay_list" v-model="ay" item-text="ay" item-value="id"
                        label="Academic Year" dense outlined placeholder="Select Academic Year"></v-autocomplete>
                </v-col>
            </v-row>
            <v-row justify="center" align="center" v-if="ay != null">
                <v-col cols="12" sm="4" md="4" class="pt-5 mt-2">
                    <v-file-input placeholder="CSV of student data" prepend-icon="mdi-file" label="Student Data"
                        show-size flat rounded outlined dense v-model="file"></v-file-input>
                </v-col>
                <v-col cols="12" sm="4" md="4" class="pt-0 mt-0">
                    <a 
                        href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/Edit_Bulk_Students_Registration.csv">
                        <v-btn :loading="loading3" :disabled="loading3" color="blue-grey" outlined
                            class="ma-2 white--text downbtn button" @click="loader = 'loading3'">
                            Download import CSV format
                            <v-icon right dark>mdi-cloud-download</v-icon>
                        </v-btn>
                    </a>
                </v-col>
            </v-row>
            <v-row justify="center" align="center">
                <v-btn class="button" @click="submitFile" :loading="output_load">Submit</v-btn>
            </v-row>
            <v-col cols="12" sm="12" md="12">
                <template v-if="load == true">

                    <v-card class="mb-4">
                        <v-card-title class="green--text">
                            Success List
                        </v-card-title>

                        <v-data-table dense :headers="headers" :items="successList" class="elevation-1 mytable"
                            :search="search" :loading="output_load">
                        </v-data-table>
                    </v-card>


                    <v-card>
                        <v-card-title class="red--text">
                            Failed List
                        </v-card-title>

                        <v-data-table dense :headers="headers" :items="failList" class="elevation-1 mytable"
                            :search="search" :loading="output_load">
                        </v-data-table>
                    </v-card>

                </template>
            </v-col>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },
    /*
  Defines the data used by the component
*/
    data() {
        return {
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: '',
            file: null,
            // extraBreadcrumbItems: [
              

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            statuslist: [],
            successList: [],
            failList: [],
            load: false,
            loading3: false,
            search: "",
            ay_list: null,
            ay: null,
            headers: [

                { text: "Sr. No.", value: "sereal_no" },
                { text: "Learner Id", value: "learner" },
                { text: "Status", value: "status" },

                { text: "Full Name", value: "fullname" },
                { text: "First Name", value: "firstname" },
                { text: "Middle Name", value: "middlename" },
                { text: "Last Name", value: "lastname" },
                { text: "Mother First Name", value: "mother_first_name" },
                { text: "Standard", value: "standard" },
                { text: "Division", value: "division" },
                { text: "Roll Number", value: "rollnumber" },
                { text: "Date of Birth", value: "birthdate" },
                { text: "Birth Place", value: "birth_place" },
                { text: "Aadhaar No", value: "aadhar_no" },
                { text: "Category", value: "category" },
                { text: "Parent Email", value: "parentemail" },
                { text: "Contact Number", value: "contactnumber" },
                { text: "Emergency Contact Name", value: "emergency_contact_name" },
                { text: "Emergency Contact Number", value: "emergency_contact_number" },
                { text: "Gender", value: "gender" },
                { text: "Blood Group", value: "bloodgroup" },
                { text: "Cast", value: "cast" },
                { text: "Saral Id", value: "saral_id" },
                { text: "GR Number", value: "gr_number" },
                // { text: "PEN No", value: "pen_no" },
                { text: "Father Full Name", value: "father_full_name" },
                { text: "Father Contact No", value: "father_contact_no" },
                { text: "Father Email", value: "father_email" },
                { text: "Mother Contact No", value: "mother_contact_no" },
                { text: "Mother Email", value: "mother_email" },
                { text: "Emergency Contact Address", value: "emergency_contact_address" },
                { text: "Secondary Parent Email", value: "secondary_email" },
                { text: "Secondary Parent Mobile No", value: "secondary_parent_mobile_no" },

                { text: "Apaar Id", value: "apaar_id" },
                { text: "Nationality", value: "nationality" },
                { text: "Mother Tongue", value: "mother_tongue" },
                { text: "Sub Caste", value: "sub_caste" },
                { text: "Birth Place/City", value: "birth_place_city" },
                { text: "Taluka", value: "taluka" },
                { text: "District", value: "district" },
                { text: "State", value: "state" },
                { text: "Country", value: "country" },
                // { text: "Date of Birth in Words", value: "date_of_birth_in_words" },
                { text: "Previous School & Std", value: "previous_school_and_std" },
                { text: "Date of Admission", value: "admission_date" },
                { text: "Birth Taluka", value: "birth_taluka" }, // Added
                { text: "Birth District", value: "birth_district" }, // Added
                { text: "Birth State", value: "birth_state" },
                { text: "Birth Country", value: "stud_birthcountry" },
                
            ],
            output_load: false,
        };
    },
    mounted() {
        axios
            .post("/InstallmentStructureDetails/importLearnerSelectionHome")
            .then((res) => {
                this.ay_list = res.data.ay_list;
            })
            .catch((error) => {
                this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            })
            .finally(() => { });
    },
    methods: {
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        submitFile() {
            if (this.file == null) {
                alert("Please select the file!");
            } else {
                this.output_load = true;
                let formData = new FormData();
                //console.log(this.file.size)
                formData.append("file", this.file);
                formData.append("ay", this.ay);
                //console.log(formData)
                axios
                    .post("RoleManagement/importEditStudentRegistration", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.successList = res.data.statuslist.success || [];
                            this.failList = res.data.statuslist.fail || [];

                            this.load = true;
                            this.showSnackbar(
                                "#4caf50",
                                "Updated Successfully..."
                            ); // show snackbar on success
                            //this.getsubjectoffering()
                            // Object.assign(this.courselist[this.editedIndex], this.editedItem);
                        }
                    })
                    .catch(function () {
                        console.log("FAILURE!!");
                    })
                    .finally(() => {
                        this.output_load = false;
                    });
                //     }
            }
        }, //end of the fuction

        /*
    Handles a change on the file upload
  */
    },
};
</script>
<style scoped>
.downbtn {
    float: right;
}

.mytable /deep/ thead th {
    background: #0f2027;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}
</style>
